import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Stats from "./components/Stats";
import Categories from "./components/Categories";
import Featured from "./components/Featured";
import Collections from "./components/Collections";
import Latest from "./components/Latest";
import Voices from "./components/Voices";
import Faq from "./components/Faq";
import About from "./components/About";
import Cta from "./components/Cta";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Stats />
        <Categories />
        <Featured />
        <Collections />
        <Latest />
        <Voices />
        <Faq />
        <About />
        <Cta />
      </main>
      <Footer />
      <BackToTop />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "大黄丫头漫画多久更新一次？",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "大黄丫头漫画目前每周更新 2-3 话，通常是周二、周四、周六晚上更新，节假日还会有特别篇放出。",
                },
              },
              {
                "@type": "Question",
                name: "大黄丫头漫画可以在手机上轻松看吗？",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "可以，官网已针对电脑、平板和手机做了完整响应式适配，支持上下滑动阅读。",
                },
              },
              {
                "@type": "Question",
                name: "网站上的笑点合集是免费的吗？",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "是的，大黄丫头漫画官网的搞笑日常与幽默片段合集全部免费，无需注册即可轻松看。",
                },
              },
            ],
          }),
        }}
      />
    </>
  );
}

export default Home;